import { useNavigate, useOutletContext } from 'react-router-dom';
import { getDocumentType, getGender } from '../../common/utils/utils';
import { formatDate01 } from '../../common/utils/utils';
import { Link } from "react-router-dom";

const valEmpty = "-";
const MaskGroupImage = "/documents/d/guest/Mask-group_1";
const AssetImage1_500w = "/documents/d/guest/44471622448-1-p-500";
const AssetImage2_500w = "/documents/d/guest/image-p-500";
const ActualizarIcon = '/documents/d/guest/actualizar-1';
const IconDp01 = '/documents/d/guest/icon-dp-01';
const IconDp02 = '/documents/d/guest/icon-dp-02';
const IconDp03 = '/documents/d/guest/icon-dp-03';
const IconDp04 = '/documents/d/guest/icon-dp-04';
const IconDp05 = '/documents/d/guest/icon-dp-05';
const IconDp06 = '/documents/d/guest/icon-dp-06';
const IconDp07 = '/documents/d/guest/icon-dp-07';
const IconDp08 = '/documents/d/guest/icon-dp-08';
const IconDp09 = '/documents/d/guest/icon-dp-09';
const IconDp10 = '/documents/d/guest/icon-dp-10';
const IconDp11 = '/documents/d/guest/icon-dp-11';
const IconDp12 = '/documents/d/guest/icon-dp-12';
const IconDp13 = '/documents/d/guest/icon-dp-13';
const IconDp14 = '/documents/d/guest/icon-dp-14';
const IconDp15 = '/documents/d/guest/icon-dp-15';

const DatosPerson = () => {
  const navigate = useNavigate();

  const { userSantias } = useOutletContext<{ userSantias: { names: string; lastUpdate: string; firstSurName?: string; secondSurName?: string; marriedSurname?: string; birthDate?: string; gender?: string; identityDocumentTypeId?: string; identityDocument?: string; maritalStatusName?: string; birthCountryName?: string; email?: string; phoneNumber?: string; departmentName?: string; stateName?: string; districtName?: string; streetTypeName?: string; address?: string; addressNumber?: string } }>();


  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <section className="hero relative">
        <div className="padding-global z-index">
          <div className="padding-section-large">
            <div className="container-medium">
              <div className="hero_wrp is-mig">
                <div className="hero_box">
                  <div className="title-component">
                    <h1 className="title">Datos personales</h1>
                    <div className="line-title"></div>
                  </div>
                  <div>¡No esperes más y mantén tu perfil al día!</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="banner_bg is-ajuste">
          <img
            loading="lazy"
            src={MaskGroupImage}
            alt=""
            className="banner_person-full is-medium movil"
          />
          <img
            sizes="(max-width: 479px) 100vw, (max-width: 767px) 320px, (max-width: 991px) 28vw, 572.25px"
            srcSet={`${AssetImage1_500w} 500w, /documents/d/guest/44471622448-1 585w`}
            alt=""
            src="/documents/d/guest/44471622448-1"
            loading="lazy"
            className="banner_person-full is-medium desp"
          />
          <img
            sizes="(max-width: 991px) 100vw, 613.921875px"
            srcSet={`${AssetImage2_500w} 500w, /documents/d/guest/image 785w`}
            alt=""
            src="/documents/d/guest/image"
            loading="lazy"
            className="banner_person-full medium is-ajuste desp"
          />
        </div>
      </section>
      <section className="info-h">
        <div className="padding-global">
          <div className="padding-section-medium">
            <div className="container-medium">
              <div className="info_wrp is-left">
                <div className="info_txt-subtitle">
                  <img src={ActualizarIcon} loading="lazy" alt="" className="banner_actualizar-icon" />
                  <div className="text-block-4">Última actualización: {formatDate01(userSantias.lastUpdate)}</div>
                </div>
                <div className="info_inputs w-form">
                  <form id="email-form" name="email-form" data-name="Email Form" method="get" className="info_formvg" data-wf-page-id="6721d9a25383f72ac3d90c62" data-wf-element-id="b67053ef-4d82-68f7-a835-2cf9ebdffd22">
                    <div className="datos_item">
                      <img src={IconDp01} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Nombres</div>
                        <div className="datos_item-text">{userSantias.names ? userSantias.names : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-_7879a4b0-54ee-93d5-a10b-99e89dc2956a-c3d90c62" className="datos_item">
                      <img src={IconDp01} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Apellido Paterno</div>
                        <div className="datos_item-text">{userSantias.firstSurName ? userSantias.firstSurName : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-bdac30d9-f0e2-96a8-2b51-b4cd86e02c7e-c3d90c62" className="datos_item">
                      <img src={IconDp01} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Apellidos Materno</div>
                        <div className="datos_item-text">{userSantias.secondSurName ? userSantias.secondSurName : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-fc6446ba-9fc6-c574-f79b-2b4ace8791c7-c3d90c62" className="datos_item">
                      <img src={IconDp01} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Apellido de casada</div>
                        <div className="datos_item-text">{userSantias.marriedSurname ? userSantias.marriedSurname : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-_49c32ef5-33d2-215c-723f-eb35e1e2a7ea-c3d90c62" className="datos_item">
                      <img src={IconDp02} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Fecha de nacimiento</div>
                        <div className="datos_item-text">{userSantias.birthDate ? (userSantias.birthDate) : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-_5561a9bc-613f-cd8e-ebb2-c5c2cbeeadda-c3d90c62" className="datos_item">
                      <img src={IconDp03} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Género</div>
                        <div className="datos_item-text">{userSantias.gender ? getGender(userSantias.gender) : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-_5e5334be-cb2e-fda1-0722-4aca659b675c-c3d90c62" className="datos_item">
                      <img src={IconDp04} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Tipo de documento</div>
                        <div className="datos_item-text">{userSantias.identityDocumentTypeId ? getDocumentType(Number(userSantias.identityDocumentTypeId)) : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-_7b5bef2d-d4a4-427d-7fe4-7caa13fa4921-c3d90c62" className="datos_item">
                      <img src={IconDp05} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Número de documento</div>
                        <div className="datos_item-text">{userSantias.identityDocument ? userSantias.identityDocument : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-_47b36acb-aa18-649a-b4f2-438b19868508-c3d90c62" className="datos_item">
                      <img src={IconDp06} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Estado civil</div>
                        <div className="datos_item-text">{userSantias.maritalStatusName ? userSantias.maritalStatusName : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-_866e7ea2-25fb-017e-6f1e-f461fdd19a97-c3d90c62" className="datos_item">
                      <img src={IconDp07} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Nacionalidad</div>
                        <div className="datos_item-text">{userSantias.birthCountryName ? userSantias.birthCountryName : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-_34fdc7e8-8b03-8869-195c-efe3cac7d7f4-c3d90c62" className="datos_item">
                      <img src={IconDp08} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Correo</div>
                        <div className="datos_item-text">{userSantias.email ? userSantias.email : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-e44eff99-c80a-ce4a-66b1-e6cfc3a0d496-c3d90c62" className="datos_item">
                      <img src={IconDp09} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Celular</div>
                        <div className="datos_item-text">{userSantias.phoneNumber ? userSantias.phoneNumber : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-c2a2aa3a-4a49-7446-c944-4bfaf08b00cd-c3d90c62" className="datos_item">
                      <img src={IconDp10} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Departamento</div>
                        <div className="datos_item-text">{userSantias.departmentName ? userSantias.departmentName : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-_1f8657d1-b64d-6c3c-96b8-9cabddae0529-c3d90c62" className="datos_item">
                      <img src={IconDp11} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Provincia</div>
                        <div className="datos_item-text">{userSantias.stateName ? userSantias.stateName : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-_3911008b-c012-570f-2899-8874fc0aceb6-c3d90c62" className="datos_item">
                      <img src={IconDp12} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Distrito</div>
                        <div className="datos_item-text">{userSantias.districtName ? userSantias.districtName : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-_23145048-5449-7222-9cc9-a3272a7d6f01-c3d90c62" className="datos_item">
                      <img src={IconDp13} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Tipo via</div>
                        <div className="datos_item-text">{userSantias.streetTypeName ? userSantias.streetTypeName : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-_02f5a781-05f0-71f9-2e9e-130b0f3e9642-c3d90c62" className="datos_item">
                      <img src={IconDp14} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Dirección</div>
                        <div className="datos_item-text">{userSantias.address ? userSantias.address : valEmpty}</div>
                      </div>
                    </div>
                    <div id="w-node-_59ff413e-9578-ad17-272f-9a3c989d0b59-c3d90c62" className="datos_item">
                      <img src={IconDp15} loading="lazy" alt="" className="banner_flex-inputs-icon" />
                      <div className="info_input-bx">
                        <div className="datos_item-label">Número dpto.</div>
                        <div className="datos_item-text">{userSantias.addressNumber ? userSantias.addressNumber : valEmpty}</div>
                      </div>
                    </div>
                  </form>
                  <br></br>
                  <br></br>
                  <div className="info_form-btns">
                    <div className="dp_block-btn">
                      <a onClick={() => handleBack()} className="button is-outline is-movile w-button">Atrás</a>
                    </div>
                    <div id="w-node-_24e1b08d-8be0-3871-4a78-0b48d96888a3-c3d90c62" className="dp_block-btn">
                      <Link className="button w-button" to={"/mi-perfil/estas-seguro-de-actualizar-tu-informacion"} state={{ payload: userSantias }}>Actualizar datos</Link>
                    </div>
                  </div>
                  <div className="w-form-done">
                    <div>Thank you! Your submission has been received!</div>
                  </div>
                  <div className="w-form-fail">
                    <div>Oops! Something went wrong while submitting the form.</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DatosPerson;
